import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import VesselDetails from "../../../components/VesselDetails/VesselDetails";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import Loader from "../../../common/Loader/Loader";

const baseUrl = process.env.REACT_APP_BASE_URL;
const EditVesselPage = () => {
	const params = useParams();
	const vesselMstId = parseInt(params.vesselMstId);

	const [vesselData, setVesselData] = useState();
	const [loader, setLoader] = useState(false);

	const imoBasedVesselData = async (vesselMstId) => {
		setLoader(true);
		try {
			const response = await axiosHttp.get(
				`${baseUrl}api/MyFleet/GetVesselById?vesselMstId=${vesselMstId}`
			);
			if (response?.data) {
				setLoader(false);
				setVesselData(response?.data?.Data);
			}
		} catch (error) {
			setLoader(false);
			emitToasterMsg("error", "Error", error.message);
		}
	};

	useEffect(() => {
		imoBasedVesselData(vesselMstId);
	}, [vesselMstId]);

	return (
		<>
			{loader && <Loader />}
			{vesselData && (
				<VesselDetails
					vesselData={vesselData}
					vesselMstId={vesselMstId}
					isEnrollVessel={true}
					regulations={null}
					isReportTab={false}
				/>
			)}
		</>
	);
};

export default EditVesselPage;
